import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mr-3 font-medium text-gray-600 text-sm" }
const _hoisted_2 = { class: "ml-3 font-medium text-gray-600 text-sm" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Tooltip = _resolveComponent("Tooltip")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["flex items-center cursor-pointer toggle", _ctx.currentValue ? 'checked' : '']),
    for: "toggle",
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggle && _ctx.toggle(...args)))
  }, [
    _createVNode(_component_Tooltip, {
      direction: "left",
      "extend-width": "true",
      message: _ctx.textLeftTooltip
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.textLeft), 1)
      ]),
      _: 1
    }, 8, ["message"]),
    _cache[1] || (_cache[1] = _createElementVNode("div", { class: "relative" }, [
      _createElementVNode("div", { class: "bg block bg-gray-200 w-12 h-7 rounded-full" }),
      _createElementVNode("div", { class: "dot absolute left-1 bg-white top-1 w-5 h-5 rounded-full transition" })
    ], -1)),
    _createVNode(_component_Tooltip, {
      direction: "right",
      "extend-width": "true",
      message: _ctx.textRightTooltip
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.textRight), 1)
      ]),
      _: 1
    }, 8, ["message"])
  ], 2))
}